/**
 * 文件路径: D:\XXY\MeiShan_Project\frontend\shared\types\common.ts
 * 通用类型定义
 */

// API响应通用结构
export interface ApiResponse<T = unknown> {
  data: T
  message: string
  status: 'success' | 'error'
}

// 分页响应结构
export interface PaginatedResponse<T> {
  count: number
  next: string | null
  previous: string | null
  results: T[]
}

// 通用分页参数
export interface PaginationParams {
  page?: number
  page_size?: number
}

// 用户基础信息
export interface User {
  id: number
  username: string
  email: string
  phone_number?: string | null
  first_name?: string
  last_name?: string
  display_name?: string
  employee_no?: string | null
  employee_code?: string | null
  is_active: boolean
  is_staff: boolean
  is_superuser: boolean
  operator_department_id?: number | null
  operator_department_name?: string | null
  operator_city_id?: number | null
  operator_city_name?: string | null
  operator_manager_id?: number | null
  operator_manager_name?: string | null
  enterprise_id?: number | null
  merchant_id?: number | null
  user_type?: 'operator' | 'merchant' | 'enterprise'
  permissions: string[]
  roles?: string[]
  created_at: string
  updated_at: string
  // 企业信息（后端序列化器返回的关联对象）
  enterprise?: {
    id: number
    name: string
    features?: Record<string, boolean>
  } | null
  // 运营商租户信息（后端序列化器返回的关联对象）
  operator_tenant?: {
    id: number
    name: string
  } | null
  // 部门信息（后端序列化器返回的关联对象）
  department?: {
    id: number
    name: string
    parent_id?: number | null
  } | null
  // 商户信息（后端序列化器返回的关联对象）
  merchant?: {
    id: number
    name: string
  } | null
  // 商户详情（含餐厅列表，来自 UserSerializer.merchant_detail）
  merchant_detail?: {
    id: number
    name: string
    restaurants: Array<{ id: number; name: string }>
  } | null
}

// 登录请求参数
export interface LoginRequest {
  username: string
  password: string
}

// 登录响应
export interface LoginResponse {
  access: string;
  refresh: string;
  user: User;
}

// Token刷新响应
export interface RefreshTokenResponse {
  access: string
}

// 菜单项类型
export interface MenuItem {
  id: string
  title: string
  icon?: string
  path?: string
  routeName?: string  // 命名路由，用于精确跳转
  disabled?: boolean
  children?: MenuItem[]
  meta?: {
    requiresAuth?: boolean
    permissions?: string[]
    roles?: string[]
  }
}

// 错误响应类型
export enum ApiErrorCode {
  Unauthorized = 'unauthorized',
  Forbidden = 'forbidden',
  NotFound = 'not_found',
  ValidationError = 'validation_error',
  ApiError = 'api_error',
  NetworkError = 'network_error'
}

export interface ErrorDetailMap {
  [field: string]: string[]
}

export interface ErrorResponse {
  error: ApiErrorCode | string
  message: string
  status: 'error'
  detail?: string
  errors?: ErrorDetailMap
}